import { Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ContainerIcon } from '../styles';
import { ReactComponent as SecurityIcon } from './../../../../assets/security.svg';

export const CardTagGtm = ({ setShowCopyCode, setShowGtm, showGtm }) => {
  return (
    <Card
      sx={{
        padding: '16px',
        marginBlockStart: '16px',
        backgroundColor: '#fffeFe',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <Row>
        <Column xs={9}>
          <span style={{ fontSize: '20px', fontWeight: '500' }}>Google Tag Manager</span>
          <br />
          <span style={{ fontSize: '16px', fontWeight: '400', color: '#34d399' }}>(Recomendado)</span>
        </Column>
        <Column style={{ display: 'flex', justifyContent: 'end' }}>
          <ContainerIcon
            onClick={() => {
              setShowCopyCode(false);
              setShowGtm(!showGtm);
            }}
            active={showGtm}
          >
            <SecurityIcon width="44px" height="44px" style={{ padding: '8px' }} />
          </ContainerIcon>
        </Column>
      </Row>
      <Row>
        <Column xs={12}>
          <p style={{ marginBottom: '2.5rem' }}>
            Gerenciamos seus cookies, mas o GTM pode chegar primeiro, com esta opção basta instalar nosso template.
          </p>
        </Column>
      </Row>
    </Card>
  );
};
